import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

import { Product } from "../../shared/interface/product";
import { Facets } from "../../shared/interface/facets";
import { FacetsGroup } from "../../shared/interface/facets1";
import { ProductService } from "../product.service";
import { ProductSearchCriteria } from "../../shared/interface/product-search-criteria";
import { Store } from "@ngrx/store";
import * as reducers from "../../reducers";
import * as productActions from "../product.actions";
import { PreviousRouteService } from "../../shared/service/previous-route.service";

@Component({
  selector: "product-filters",
  encapsulation: ViewEncapsulation.None,
  templateUrl: "./product-filters.component.html",
  styleUrls: ["./product-filters.component.scss"],
})
export class ProductFiltersComponent implements OnInit, AfterViewInit {
  @Input() screenWidth: string;
  @Input() productFilter: Facets[];
  @Input() productFilterGroup: FacetsGroup[];
  @Output() filterChange = new EventEmitter();
  @Output() clearFilter = new EventEmitter();
  @Output() toggleReset = new EventEmitter();
  @ViewChild("filtersReset") filtersResetBtn: ElementRef;
  disableReset: boolean = true;
  //defaultMinRangeVal;
  //defaultMaxRangeVal;
  groupTypes = ["geforce", "nvrtx", "quadro"];
  someRange = [];
  filterCriteria = {
    query: "Geforce",
  };
  maxToShow: number = 8;
  maxToshowGroup: number = 3;

  maxes = [];
  showMoreLessStates = [];

  maxesGroup = [];
  showMOreLessGroupStates = [];
  showMoreLabel: string = "show_more";
  showLessLabel: string = "show_less";
  divMessages;
  data = [];
  //showMore = 8;
  showMaxQ: boolean;
  constructor(
    private store: Store<reducers.State>,
    private previousRouteService: PreviousRouteService
  ) { }

  ngOnInit() {
    this.store.select(reducers.getProductFilter).subscribe((productFilter) => {
      productFilter.forEach((element) => {
        if (element.displayName === "gpu") {
          element.filterValues.forEach((value) => {
            if (value.checked && value.groupType === "geforce") {
              this.showMOreLessGroupStates[0] = false;
            } else if (value.checked && value.groupType === "nvrtx") {
              this.showMOreLessGroupStates[1] = false;
            } else if (value.checked && value.groupType === "quadro") {
              this.showMOreLessGroupStates[2] = false;
            }
          });
        }
        if (element.displayName === "max_q") {
          this.showMaxQ =
            element.filterValues.map((x) => x.dispValue).indexOf("1") > -1 &&
            element.filterValues.filter((x) => x.dispValue == "1")?.[0]?.units >
            0;
        }
      });
    });
    // this.divMessages = appendElement;
    this.store
      .select(reducers.getProductParams)
      .subscribe((params: ProductSearchCriteria) => {
        this.disableReset = false;
        let arr = Object.keys(params);
        if (
          params.page === 1 &&
          params.limit &&
          params.locale &&
          (arr.length === 3 ||
            (arr.length === 4 &&
              (arr.indexOf("search") >= 0 || arr.indexOf("sorting") >= 0)) ||
            (arr.length === 5 &&
              arr.indexOf("search") >= 0 &&
              arr.indexOf("sorting") >= 0))
        ) {
          this.disableReset = true;
        }

        this.filtersResetBtn &&
          (this.filtersResetBtn.nativeElement.disabled = this.disableReset);
        this.toggleReset.emit(this.disableReset);
      });
  }
  ngAfterViewInit() { }

  subMenu(elementFilters) {
    let html = "";
    html = html + "<li>" + elementFilters.dispValue + "</li>";
    return html;
  }

  changed(filterItem, values, val) {
    let payload;

    if (filterItem && filterItem.fieldType === "checkbox") {
      payload = {
        displayName: filterItem.displayName,
        filterField: filterItem.filterField,
        values: values,
        trueValue: val,
        fieldType: filterItem.fieldType,
        filterValues: filterItem.filterValues,
      };
    }
    if (val && val.type && val.type.fieldType === "range") {
      payload = {
        displayName: val.type.displayName,
        filterField: val.type.filterField,
        fieldType: val.type.fieldType,
        values: val.range,
        filterValues: [
          val.type.selectedMinRangeVal,
          val.type.selectedMaxRangeVal,
        ],
        defaultMinRangeVal: val.type.defaultMinRangeVal,
        defaultMaxRangeVal: val.type.defaultMaxRangeVal,
      };
    }
    localStorage.removeItem("previousFilterGroupCache");
    if (filterItem && filterItem.displayName == "gpu") {
      localStorage.setItem(
        "previousFilterGroupCache",
        JSON.stringify(filterItem)
      );
    }

    this.previousRouteService.setIsFromCompare(false);
    this.store.dispatch(new productActions.UpdateProductParams(payload));
  }
  changedGroup(i, values, val) {
    console.log("changedGroup");
    let productfilters;
    let payload,
      groupValue = values.displayName,
      filterOptions = "";
    this.productFilter.forEach((element) => {
      if (element.displayName === "gpu") {
        productfilters = element;
        element.filterValues.forEach((value) => {
          if (value.groupType + "_group" === groupValue) {
            filterOptions = filterOptions + "," + value.dispValue;
          }
        });
      }
    });
    groupValue = groupValue.substr(0, groupValue.indexOf("_"));
    payload = {
      displayName: "gpu",
      filterField: "gpu_filter",
      values: {
        dispValue: groupValue + filterOptions,
        dispValueDesription: null,
        units: 1,
        checked: false,
        imageURL: null,
      },
      trueValue: val,
      fieldType: values.fieldType,
      filterValues: productfilters.filterValues,
    };
    this.previousRouteService.setIsFromCompare(false);
    this.store.dispatch(new productActions.UpdateProductParams(payload));
    if (val) {
      this.showMOreLessGroupStates[i] = false;
    }
  }

  onFilterRangeInputChange(event) {
    console.log("onFilterRangeInputChange");
    this.filterCriteria[event.name] = [];
    this.filterCriteria[event.name].push(event.values);
    let copyOffilterCriteria = JSON.stringify(this.filterCriteria);
    this.filterChange.emit(copyOffilterCriteria);
  }

  resetFilters(e) {
    e.target.blur();
    this.clearFilter.emit();
  }

  anySelectedOutsideMaxToShow(filterValues): boolean {
    for (let i = this.maxToShow; i < filterValues.length; i++) {
      if (filterValues[i].checked) {
        return true;
      }
    }
    return false;
  }
  // for group
  anySelectedOutsideMaxToShowGroup(filterValues): boolean {
    if (filterValues.checked) {
      return true;
    }
    return false;
  }

  getMaxToShow(filterItemIndex, filterValues): number {
    if (this.maxes[filterItemIndex]) {
      return this.maxes[filterItemIndex];
    } else if (filterValues && this.anySelectedOutsideMaxToShow(filterValues)) {
      this.maxes[filterItemIndex] = filterValues.length;
      return filterValues.length;
    }
    return this.maxToShow;
  }

  showMore(filterItemIndex, filterValues): boolean {
    if (this.showMoreLessStates[filterItemIndex] === undefined) {
      this.showMoreLessStates[filterItemIndex] = true;
      if (filterValues && this.anySelectedOutsideMaxToShow(filterValues)) {
        this.showMoreLessStates[filterItemIndex] = false;
      }
    }
    return this.showMoreLessStates[filterItemIndex];
  }
  //for group state
  showMoreGroup(index, filterValues): boolean {
    if (this.showMOreLessGroupStates[index] === undefined) {
      this.showMOreLessGroupStates[index] = true;
      if (filterValues && this.anySelectedOutsideMaxToShowGroup(filterValues)) {
        this.showMOreLessGroupStates[index] = false;
      }
    }
    return this.showMOreLessGroupStates[index];
  }

  toggleShowMoreLess(filterItemIndex, len) {
    if (this.showMoreLessStates[filterItemIndex]) {
      this.maxes[filterItemIndex] = len;
    } else {
      this.maxes[filterItemIndex] = this.maxToShow;
    }
    this.showMoreLessStates[filterItemIndex] =
      !this.showMoreLessStates[filterItemIndex];
  }

  getShowMoreLessLabel(filterItemIndex): string {
    if (this.showMoreLessStates[filterItemIndex]) {
      return this.showMoreLabel;
    }
    return this.showLessLabel;
  }
  // for group state
  getShowMoreLessLabelGroup(filterItemIndex): string {
    if (this.showMoreLessStates[filterItemIndex]) {
      return this.showMoreLabel;
    }
    return this.showLessLabel;
  }
  // for group state
  toggleGroupFilter(index, len) {
    if (this.showMOreLessGroupStates[index]) {
      this.maxesGroup[index] = len;
    } else {
      this.maxesGroup[index] = this.maxToshowGroup;
    }
    this.showMOreLessGroupStates[index] = !this.showMOreLessGroupStates[index];
  }
}
